import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGridDataByModuleKey } from '../../../redux/selector';
import {
  fetchDataAndUpdateStore,
  fetchSelectedListAndAppendToModule,
} from '../../../redux/actions';
import SelectionRemoveModal from '../../../shared/component/SelectionRemoveModal';
import { useRef } from 'react';

// compact page-number list with ellipses (ported from the GrowthOS design)
const pageList = (cur, totalP) => {
  if (totalP <= 7) return Array.from({ length: totalP }, (_, i) => i + 1);
  const out = [1];
  if (cur > 3) out.push('…');
  const s = Math.max(2, cur - 1);
  const e = Math.min(totalP - 1, cur + 1);
  for (let i = s; i <= e; i++) out.push(i);
  if (cur < totalP - 2) out.push('…');
  out.push(totalP);
  return out;
};

const Chev = ({ d }) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const CustomStatusBar = (props) => {
  const { api, context } = props;
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [rowCount, setRowCount] = useState(0);
  const [pageSize, setPageSize] = useState(null);
  const [startRow, setStartRow] = useState(1);
  const [endRow, setEndRow] = useState(pageSize);
  const moduleKey = context?.moduleKey;

  const gridData = useSelector(getGridDataByModuleKey(moduleKey));
  const gridDataSelection = useSelector(getGridDataByModuleKey('selectionList'));
  const fullSelection = gridDataSelection?.[moduleKey] || {};
  console.log('🚀 ~ CustomStatusBar ~ fullSelection:', fullSelection);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const pendingChangeRef = useRef(null);

  // Update page info whenever pagination changes
  useEffect(() => {
    if (gridData?.totalCount || gridData?.inputPayload) {
      const totalPages = Math.ceil(gridData?.totalCount / gridData?.inputPayload?.pageSize);
      const currentPage = gridData?.inputPayload?.pageNumber;
      const rowCount = gridData?.totalCount ? gridData?.totalCount : 0;
      const pageSize = gridData?.inputPayload?.pageSize;
      const startRow = (currentPage - 1) * pageSize + 1;
      const endRow = Math.min(startRow + pageSize - 1, rowCount);

      setTotalPages(totalPages);
      setCurrentPage(currentPage);
      setRowCount(gridData?.totalCount);
      setPageSize(pageSize);
      setStartRow(startRow);
      setEndRow(endRow);
    }
  }, [gridData]);

  useEffect(() => {
    const payload = gridData?.inputPayload;
    if (gridData?.inputPayload && Object.keys(gridData.inputPayload).length > 0) {
      let newInputPayload = {
        // ...inputPayload,
        ...payload,
        pageNumber: currentPage ? currentPage : payload.pageNumber,
        pageSize: pageSize ? pageSize : payload.pageSize,
      };
      if (JSON.stringify(payload) !== JSON.stringify(newInputPayload)) {
        dispatch(
          fetchDataAndUpdateStore({
            key: moduleKey,
            inputData: newInputPayload,
          })
        );
      }
    }
  }, [pageSize, currentPage]);
  // Handle page size change
  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    const currentPageKey = `page-${currentPage}`;

    const isCurrentPageSelected =
      fullSelection && fullSelection[currentPageKey] && fullSelection[currentPageKey].length > 0;

    if (isCurrentPageSelected) {
      setShow(true); // Show confirmation modal
      pendingChangeRef.current = {
        type: 'pageSize',
        value: newSize,
      };
    } else {
      setCurrentPage(1); // Reset to page 1
      setPageSize(newSize);
    }
  };

  const handleConfirm = () => {
    setShow(false);

    dispatch(
      fetchSelectedListAndAppendToModule({
        key: moduleKey,
        selectedList: null,
      })
    );

    if (pendingChangeRef.current?.type === 'pageSize') {
      const newSize = pendingChangeRef.current.value;
      setCurrentPage(1);
      setPageSize(newSize);
      pendingChangeRef.current = null;
    }
  };

  const cp = currentPage || 1;
  const tp = totalPages || 1;
  const noun = moduleKey ? ` ${moduleKey}` : '';

  return (
    <div className="gos-pager pager">
      <div className="pager-info">
        Showing <strong>{rowCount === 0 ? 0 : startRow}</strong>–<strong>{endRow}</strong> of{' '}
        <strong>{rowCount}</strong>
        {noun}
      </div>
      <div className="pager-ctrls">
        <div className="pager-size">
          <span>Rows</span>
          <div className="pager-size-sel">
            <select onChange={handlePageSizeChange} value={pageSize || ''}>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
            <Chev d="M6 9l6 6 6-6" />
          </div>
        </div>
        <div className="pager-pages">
          <button
            className="pager-arrow"
            disabled={cp <= 1}
            onClick={() => setCurrentPage(cp - 1)}
            aria-label="Previous page"
          >
            <Chev d="M15 18l-6-6 6-6" />
          </button>
          {pageList(cp, tp).map((p, i) =>
            p === '…' ? (
              <span key={'e' + i} className="pager-gap">
                …
              </span>
            ) : (
              <button
                key={p}
                className={'pager-num' + (p === cp ? ' on' : '')}
                onClick={() => setCurrentPage(p)}
              >
                {p}
              </button>
            )
          )}
          <button
            className="pager-arrow"
            disabled={cp >= tp}
            onClick={() => setCurrentPage(cp + 1)}
            aria-label="Next page"
          >
            <Chev d="M9 18l6-6-6-6" />
          </button>
        </div>
      </div>
      {show && (
        <SelectionRemoveModal
          show={show}
          handleClose={() => setShow(false)}
          handleConfirm={handleConfirm}
          text={'All selection will be lost, Want to Proceed?'}
        />
      )}
    </div>
  );
};

export default CustomStatusBar;
